export const STORAGE_KEY = 'sanitas-ovp'

export const CATEGORY_TYPE_KVG = 'KVG'
export const CATEGORY_TYPE_VVG = 'VVG'
export const CATEGORY_TYPE_UNKONWN = 'OTHER'

export const CHANNEL_ALVA = 'ALVA'
export const CHANNEL_OVP = 'OVP'
export const CHANNEL_ENTRYWIDGET = 'ENTRYWIDGET'
export const CHANNEL_PARTNERDVP = 'PARTNERDVP'
export const CHANNEL_PARTNERWIDGET = 'PARTNERWIDGET'
export const CHANNEL_PRICEWIDGET = 'PRICEWIDGET'
export const CHANNEL_SERVICEPORTAL = 'SERVICEPORTAL'

export const COLLECTIVE_REQUIRED_FLAGS = ['MANDATORY', 'Zwingend']

export const DATE_FORMAT_DIN = 'dd.MM.yyyy'
export const DATE_FORMAT_ISO = 'yyyy-MM-dd'

export const ADULT = 'adult'
export const MINOR = 'minor'
export const SENIOR = 'senior'

export const GENDER_MALE = 'MALE'
export const GENDER_FEMALE = 'FEMALE'
export const GENDER_UNBORN = 'UNBORN'

export const MAX_PERSONS = 7

export const FREE_MOVEMENT_OF_PERSONS_COUNTRIES = ['CH', 'EU_EFTA_WITHOUT_PERMIT']

export const PAYMENT_FREQUENCIES = ['MONTHLY', 'BIMONTHLY', 'QUARTERLY', 'HALFYEARLY', 'YEARLY']

export const PAYMENT_METHOD_ESR = 'ESR'
export const PAYMENT_METHOD_LSV_PLUS = 'LSV_PLUS'
export const PAYMENT_METHOD_EBILLING = 'EBILLING'
export const PAYMENT_METHOD_DIRECT_DEBIT = 'DIRECT_DEBIT'

export const PAYMENT_METHODS = [
  PAYMENT_METHOD_ESR,
  PAYMENT_METHOD_LSV_PLUS,
  PAYMENT_METHOD_EBILLING,
  PAYMENT_METHOD_DIRECT_DEBIT,
]
export const PAYMENT_PAYOUTS = ['WITHACCOUNT', 'WITHOUTACCOUNT']

export const SMOKING_TYPES = ['CIGARETTE', 'CIGAR', 'PIPE', 'E_CIGARETTE', 'CIGARILLOS', 'THS', 'OTHER']
export const ALCOHOL_TYPES = ['BEER', 'WINE', 'LIQUOR', 'OTHER']
export const DRUG_TYPES = ['CANNABIS', 'ANABOLICA', 'HEROIN', 'COCAINE', 'LSD', 'ECSTASY', 'OTHER']

export const FRANCHISE_ADULT = [300, 500, 1000, 1500, 2000, 2500]
export const FRANCHISE_MINOR = [0, 100, 200, 300, 400, 500, 600]
export const MOVED_FROM_ABROAD = [
  'CH',
  'PERMIT_C_B_L_LONGER_3_MONTHS',
  'PERMIT_L_UNTIL_3_MONTHS',
  'PERMIT_G',
  'EU_EFTA_WITHOUT_PERMIT',
  'OTHER',
]
export const RESIDENCE_PERMITS = [
  'NOT_KNOWN',
  'B_RESIDENCE_PERMIT',
  'C_SETTLEMENT_PERMIT',
  'CI_RESIDENCE_PERMIT_WITH_WORK',
  'F_PROVISIONALLY_ADMITTED_FOREIGNER',
  'L_SHORT_TERM_RESIDENCE_PERMIT_UPTO_3_MONTH',
  'L_SHORT_TERM_RESIDENCE_PERMIT_FROM_3_MONTH',
  'N_PERMIT_FOR_ASYLUM_SEEKERS',
  'G_CROSS_BORDER_COMMUTER_PERMIT',
  'S_PERSON_IN_NEED_OF_PROTECTION',
  'SANS_PAPIER',
  'SWISS_CITIZEN',
]
export const NO_KVG_REASONS = ['CODE_100', 'CODE_147', 'CODE_148', 'CODE_153']
export const ENABLE_FILE_UPLOAD = [
  'CH',
  'PERMIT_C_B_L_LONGER_3_MONTHS',
  'PERMIT_L_UNTIL_3_MONTHS',
  'PERMIT_G',
  'CODE_100',
  'OTHER',
]

export const DOCUMENT_TYPE_CROSS_BORDER_PERMIT = 'crossborderpermit'
export const DOCUMENT_TYPE_MILITARY_SERVICE = 'militaryservice'
export const DOCUMENT_TYPE_REGISTRATION = 'registration'
export const DOCUMENT_TYPE_RESIDENCE_PERMIT = 'residencepermit'

export const FILE_UPLOAD_CONTEXT_PRE_INSURER = 'preInsurer'
export const FILE_UPLOAD_CONTEXT_ADVISORY_PROTOCOL = 'advisoryProtocol'

export const DOCUMENT_CANCELATION_KVG = 'CANCELATION_KVG'
export const DOCUMENT_CANCELATION_VVG = 'CANCELATION_VVG'
export const DOCUMENTS_TODO = [DOCUMENT_CANCELATION_KVG, DOCUMENT_CANCELATION_VVG]

export const EGATE_ACCEPTED = 'READY_FOR_TRANSMISSION'
export const EGATE_REVIEW = 'REVIEW_PENDING'

export const DOCUMENTS_ALL = 'ALL'
export const DOCUMENTS_OA_HEALTH_QUEST = 'OA_HEALTH_QUEST'
export const DOCUMENTS_APPLICATION_DENTAL = 'APPLICATION_DENTAL'

export const DEFAULT_TIME = 1000 // 1 sec in milliseconds
export const DEFAULT_DELAY_TIME = DEFAULT_TIME / 2
export const DEFAULT_FORM_DEBOUNCE_TIME = 200

export const DEFAULT_LANGUAGE = 'de'
export const DEFAULT_MASTER_TREATY = 'SA-EV'
export const DEFAULT_DISTRIBUTION_PARTNER_NUMBER = '219369'

// refer to DistributionPartnerInfoMapper.java in ovpv3 ms for futher mapping information
export const SALES_PARTNER_TYPE_PRIVATE_INSURER = 'PRIVATE_INSURER' // Privatassekuranz, based on masterTreaty
export const SALES_PARTNER_TYPE_BROKER = 'BROKER' // based on definitionBoid, has advisory protocol
export const SALES_PARTNER_TYPE_MOBILE = 'MOBILE' // mobile distribution, based on distributionPartnerNumber (FLEX-493)
export const SALES_PARTNER_TYPE_DEFAULT_SANITAS = 'DEFAULT_SANITAS' // default Sanitas distributionPartnerNumber
export const SALES_PARTNER_TYPE_DEFAULT = 'DEFAULT' // default partner, e.g. 346448 smile

export const NOTIFICATION_LIFETIME = DEFAULT_TIME * 10
export const NOTIFICATION_SUCCESS = 'success'
export const NOTIFICATION_WARNING = 'warning'
export const NOTIFICATION_ERROR = 'error'

export const VIEW_MOBILE = 'mobile'
export const VIEW_DESKTOP = 'desktop'

export const REENTRY_PREFIX_SP = 'OA'
export const REENTRY_PREFIX_DVP = 'RE'

export const SESSION_EOL = { days: 2 }

export const SESSION_TIME_TO_CLEAR = 10 * 60 * 1000
export const SESSION_TIME_TO_AUTH = 50 * 60 * 1000

export const SESSION_UNINITIALISED = 'session-empty'
export const SESSION_ACTIVE = 'session-active'

export const COBROWSE_TIME_TO_CLEAR = 10 * 1000

export const STATE_READY = 'READY'
export const STATE_LOADING = 'LOADING'

// order is important!
export const HQ_TREATMENTS_VARIANTS = ['ACTUAL_OR_PAST', 'PLANNED']

export const SAVE_NUDGE_DELAY = DEFAULT_TIME

// distributionPartnerTypes
export const DISTRIBUTION_PARTNER_TYPE_OFFERTE = 'OFFERTE'
export const DISTRIBUTION_PARTNER_TYPE_ABSCHLUSS = 'ABSCHLUSS'
export const DISTRIBUTION_PARTNER_TYPE_BETREUER = 'BETREUER'
export const DISTRIBUTION_PARTNER_TYPES = [
  DISTRIBUTION_PARTNER_TYPE_OFFERTE,
  DISTRIBUTION_PARTNER_TYPE_ABSCHLUSS,
  DISTRIBUTION_PARTNER_TYPE_BETREUER,
]

// FLEX-493
export const DISTRIBUTION_MOBILE_PARTNERNUMBERS = [
  '353527',
  '353530',
  '353542',
  '353547',
  '353550',
  '353553',
  '353556',
  '353559',
  '353562',
]

// FLEX-903
export const DISTRIBUTION_PARTNER_WITH_ADVISOR_MAIL = ['AZ-EV', 'ZV-EV', 'BU-EV', 'GE-EV', 'NA-EV', 'MO-EV']

export const COUNTRY_CODES_SWISS_AND_NEIGHBOURS = ['ch', 'de', 'at', 'it', 'fr', 'li']

export const SURVEY_TOUCHPOINT_WEBSITE = 'TP14'
export const SURVEY_TOUCHPOINT_SUBMIT = 'TP15'

export const BASKET_TYPE = {
  BASKET_NEW: 'BASKET_NEW',
  BASKET_CHANGED: 'BASKET_CHANGED',
  BASKET_EXISTING: 'BASKET_EXISTING',
  DIFF_CHANGED: 'DIFF_CHANGED',
  DIFF_EXISTING: 'DIFF_EXISTING',
  SUBMIT_NEW: 'SUBMIT_NEW',
  ALVA_NEW: 'ALVA_NEW',
}

export const PRODUCT_STATE = {
  EDITABLE: 'EDITABLE',
  READONLY: 'READONLY',
  NOT_DELETABLE: 'NOT_DELETABLE',
}

// --------- advisory protocol
export const ADVISORY_PROTOCOL_DOCUMENT_TYPE_INSURANCE_POLICY = 'INSURANCE_POLICY'
export const ADVISORY_PROTOCOL_DOCUMENT_TYPE_IDENTIFICATION = 'IDENTIFICATION'
export const ADVISORY_PROTOCOL_CHECKBOXES_ADVISOR = ['advisorInformationFormReceived', 'advisorInformationCorrect']

export const ADVISORY_PROTOCOL_CHECKBOXES_CONSENT = [
  'consentKnowProducts',
  'consentQuestionsAnswered',
  'consentCorrectlyAnsweredQuestions',
  'consentSendInformation',
]

export const ADVISORY_PROTOCOL_CHECKBOXES_REASON = [
  'reasonContactedAdvisor',
  'reasonAdvisorContactedMe',
  'reasonCallCenter',
  'reasonAdvertising',
]

export const SIGNATURE_MAX_EMPTY_PERCENTAGE = 98.75

// --------- section routing ---------

// --------- route indices
export const ROUTE_INDEX_PERSONS = 0
export const ROUTE_INDEX_OFFERS = 1
export const ROUTE_INDEX_OFFERS_INCENTIVE = 1.5
export const ROUTE_INDEX_BASKET = 2
export const ROUTE_INDEX_APPLICATION_ONBOARDING = 3
export const ROUTE_INDEX_APPLICATION_PERSONAL_DATA = 4
export const ROUTE_INDEX_APPLICATION_ADMIN_DATA = 5
export const ROUTE_INDEX_APPLICATION_EXISTING_CUSTOMER_DATA = 6
export const ROUTE_INDEX_APPLICATION_HEALTHQUESTIONS = 7
export const ROUTE_INDEX_SUBMIT = 8
export const ROUTE_INDEX_ADVISORY_PROTOCOL = 9
export const ROUTE_INDEX_SIGNATURE_ENTRY = 10
export const ROUTE_INDEX_SIGNATURE_VERIFICATION = 11
export const ROUTE_INDEX_NEXT_STEPS = 12

// --------- route names
export const ROUTE_NAME_PERSONS = 'persons'
export const ROUTE_NAME_OFFERS = 'TODO'
export const ROUTE_NAME_OFFERS_INCENTIVE = 'TODO'
export const ROUTE_NAME_BASKET = 'TODO'
export const ROUTE_NAME_APPLICATION_ONBOARDING = 'TODO'
export const ROUTE_NAME_APPLICATION_PERSONAL_DATA = 'application-personal-data'
export const ROUTE_NAME_APPLICATION_ADMIN_DATA = 'application-administrative-data'
export const ROUTE_NAME_APPLICATION_EXISTING_CUSTOMER_DATA = 'application-existing-customer-data'
export const ROUTE_NAME_APPLICATION_HEALTHQUESTIONS = 'application-healthquestions'
export const ROUTE_NAME_SUBMIT = 'TODO'
export const ROUTE_NAME_ADVISORY_PROTOCOL = 'advisory-protocol'
export const ROUTE_NAME_SIGNATURE_ENTRY = 'TODO'
export const ROUTE_NAME_SIGNATURE_VERIFICATION = 'TODO'
export const ROUTE_NAME_NEXT_STEPS = 'next-steps'

// --------- route indices Aide
export const ROUTE_INDEX_AIDE_ENTRY = 100
export const ROUTE_INDEX_AIDE_PERSONS = 110
export const ROUTE_INDEX_AIDE_KVG_PRODUCT = 120
export const ROUTE_INDEX_AIDE_KVG_PRODUCT_FRANCHISE = 121
export const ROUTE_INDEX_AIDE_KVG_PRODUCT_ACCIDENT = 122

export const ROUTE_INDEX_AIDE_HOSP_PRODUCT = 130
export const ROUTE_INDEX_AIDE_HOSP_PRODUCT_UPGRADE = 131

export const ROUTE_INDEX_AIDE_VVG_GROUPS = 140
export const ROUTE_INDEX_AIDE_VVG_GROUP = 141

export const ROUTE_INDEX_AIDE_BASKET = 150

// --------- section routing END ---------

export const PARTNER_WIDGET_RESTART_TIMEOUT = 15 * DEFAULT_TIME

// --------- Existing Customer Login ----------
export const LOGIN_ERROR_STATE = {
  LOCKED: 'LOCKED',
  LOGGED_OUT: 'LOGGED_OUT',
  GENERAL: 'GENERAL',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
}
export const HN_VERIFICATION_STATE = {
  VALID: 'VALID',
  VERIFY_CARD: 'VERIFY_CARD',
  VERIFY_QUESTION: 'VERIFY_QUESTION',
  LOCKED_TEMPORARILY: 'LOCKED_TEMPORARILY',
  VERIFIED: 'VERIFIED',
}

// --------- Price Widget ----------
export const PRICE_WIDGET_MAX_TABS_SIZE = 3
